import {createContext, useContext, useEffect, useMemo, useState} from "react";
import {getDatabaseInformation} from "../api/dashboard/getDatabaseInformation";

const DatabaseInformationContext = createContext();

export function DatabaseInformationProvider({children}) {
    const [loading, setLoading] = useState(true);
    const [databaseInformation, setDatabaseInformation] = useState({
        lastCalculationTime: null,
        schema: [],
    });

    useEffect(() => {
        async function fetchData() {
            try {
                const data = await getDatabaseInformation();
                console.log("Fetched database information:", data);
                setDatabaseInformation(data);
            } catch (e) {
                console.error("Error fetching database information:", e);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    const value = useMemo(() => {
        return {
            loading,
            ...databaseInformation,
        };
    }, [loading, databaseInformation]);

    return (
        <DatabaseInformationContext.Provider value={value}>
            {children}
        </DatabaseInformationContext.Provider>
    );
}

export function useDatabaseInformation() {
    const context = useContext(DatabaseInformationContext);

    if (!context) {
        throw new Error(
            "useDatabaseInformation must be used within a DatabaseInformationProvider"
        );
    }
    return context;
}
